const pathUrl = {
  additionalDocuments: '/v1/documents/additional',
  cancelShift: '/v1/shifts/cancel',
  createLog: '/v1/logs',
  getAvailableShifts: '/v1/shifts/available',
  getCities: '/v1/cities/',
  getDocuments: '/v1/documents/',
  getDriverProfile: '/v1/drivers/',
  getShifts: '/v1/shifts',
  getTraining: '/v1/trainings',
  getVehiclePhotos: '/v1/vehicles/photos/',
  joinShift: '/v1/shifts',
  logout: '/v1/auth/logout/',
  notification: '/v1/notifications',
  onboard: '/v1/auth/onboard/',
  postVehiclePhotos: '/v1/vehicles/photos/',
  shiftPreference: '/v1/shifts/preferences',
  skipOnboard: '/v1/auth/onboard-skip/',
  updateDocuments: '/v1/documents/',
  updateProfile: '/v1/drivers/',
  updateShift: '/v1/shifts/',
  updateVehiclePhotos: '/v1/vehicles/photos/',
  verify: '/v1/auth/verify/',
}

export default pathUrl
